import { makeStyles } from "@mui/styles";
import type { FC } from "react";
import { type Range, DateRange as RangePicker } from "react-date-range";
import * as locales from "react-date-range/dist/locale";
import { getCalendarLocale, getLocale } from "src/i18n";

interface DateRangeProps {
    state?: Range[];
    minDate?: Date;
    maxDate?: Date;
    disableFuture?: (date: Date) => boolean;
    handleSetState: (states: Range[]) => void;
    onRangeFocusChange?: (focusedRange: number[] | undefined) => void;
}

const useStyles = makeStyles(() => ({
    calendar: {
        fontSize: 12,
    },
}));

const locale = getLocale();
const calendarLocale = getCalendarLocale(locale);

const DateRange: FC<DateRangeProps> = ({
    state,
    disableFuture,
    handleSetState,
    minDate,
    maxDate,
    onRangeFocusChange,
}) => {
    const classes = useStyles();

    return (
        <RangePicker
            months={2}
            minDate={minDate}
            maxDate={maxDate}
            className={classes.calendar}
            direction="horizontal"
            onRangeFocusChange={onRangeFocusChange}
            disabledDay={(date) => (disableFuture ? disableFuture(date) : false)}
            locale={locales[calendarLocale]}
            onChange={(item) => {
                handleSetState([item.selection ?? item.selectionTantamount]);
            }}
            rangeColors={["primary"]}
            ranges={
                state.map((state) => {
                    return { ...state, color: "#394DFF" };
                }) ?? []
            }
            weekStartsOn={1}
        />
    );
};

export default DateRange;
